import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticStyle:{"background-color":"#f8f9fe"}},[_c('AppBar'),_c(VMain,[_c(VContainer,[_c('router-view',{attrs:{"linguaSelecionada":_vm.linguaSelecionada}})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }